angular
  .module('app', [
    'ngAnimate',
    'ngMessages',
    'ngSanitize',
    'monospaced.elastic',
    'ui.bootstrap.modal',
    'ui.bootstrap.dropdown',
    // 'ui.bootstrap.tabs',
    'uib/template/modal/window.html',
    // 'uib/template/tabs/tab.html',
    // 'uib/template/tabs/tabset.html',
    'ui.router',
  ])

  .constant('$env', {
    API: '/api/v3',
  })

  .config(function ($urlRouterProvider, $urlMatcherFactoryProvider, $httpProvider, $sceDelegateProvider) {
    $urlRouterProvider.otherwise('/');

    // make a trailing slashe optional
    $urlMatcherFactoryProvider.strictMode(false);

    $httpProvider.interceptors.push('authInterceptor');

    $sceDelegateProvider.resourceUrlWhitelist([
      'self',
    ]);
  })

  .run(function ($rootScope, $state, $transitions, $window, $dialog) {
    $rootScope.$state = $state;

    $rootScope.$on('AUTH_REQUIRED', (event) => {
      event.preventDefault();

      $window.location.href = '/login';
    });

    $transitions.onError({}, (transition) => {
      const error = transition.error();

      if (error.detail && error.detail.status) {
        if (error.detail.status !== 401) {
          $dialog.error('Whoops, looks like something went wrong.');
        }
      }
    });
  });
